import alt from "../alt";
import CouponUtil from "../utils/CouponUtil";
import CouponActions from "../actions/CouponActions";
import PersonStore from "../stores/PersonStore";
import OrderActions from "../actions/OrderActions";

class CouponStore {
  constructor() {
    this.bindActions(CouponActions);

    this.state = {
      isCheckingCode: false,
      isCouponValid: false,
      couponError: null,
      couponName: null,
      couponIsGiftCard: false
    };
  }

  onCheckCouponCode(data) {
    this.setState({
      isCheckingCode: true
    });

    CouponUtil.check(PersonStore.getState().token, data.code, data.order)
      .then(result => {
        this.setState({
          isCheckingCode: false,
          isCouponValid: result.is_applicable,
          couponError: result.error,
          couponName: result.name,
          couponIsGiftCard: !!result.gift_card
        });

        if (result.is_applicable) {
          OrderActions.updateCurrentOrder.defer({
            coupon_code: data.code,
            coupon: result
          });
        } else {
          OrderActions.updateCurrentOrder.defer({
            coupon_code: null,
            coupon: null
          });
        }
      })
      .catch(CouponActions.checkFailed);
  }

  onCheckFailed(e) {
    this.setState({
      isCheckingCode: false,
      isCouponValid: false,
      couponError: e.message,
      couponName: null,
      couponIsGiftCard: false
    });
  }

  onReset() {
    this.setState({
      isCheckingCode: false,
      isCouponValid: false,
      couponError: null,
      couponName: null,
      couponIsGiftCard: false
    });
  }
}

export default alt.createStore(CouponStore, "CouponStore");



// WEBPACK FOOTER //
// ./src/app/stores/CouponStore.js